/**
 * Shared menu configuration for Backoffice
 * Used by both BackofficeLayout (sidebar) and BackofficeUsers (role permissions)
 * Adding new menus here will automatically add them to both places
 */

export const BACKOFFICE_MENUS = [
  { key: "dashboard", label: "Dashboard", icon: "LayoutDashboard", path: "/backoffice/dashboard" },
  { key: "customers", label: "Customers", icon: "Building2", path: "/backoffice/customers" },
  { key: "support_tickets", label: "Support Tickets", icon: "Headphones", path: "/backoffice/support" },
  { key: "users_roles", label: "Users & Roles", icon: "Users", path: "/backoffice/users" },
  { key: "invoices", label: "Invoices", icon: "FileText", path: "/backoffice/invoices" },
  { key: "subscriptions", label: "Subscriptions", icon: "CreditCard", path: "/backoffice/subscriptions" },
  { key: "referrals", label: "Referrals", icon: "Gift", path: "/backoffice/referrals" },
  { key: "accounts", label: "Accounts & Billing", icon: "Receipt", path: "/backoffice/accounts" },
  { key: "cms", label: "Content & CMS", icon: "FileEdit", path: "/backoffice/cms" },
  { key: "marketing", label: "Marketing", icon: "Megaphone", path: "/backoffice/marketing" },
  { key: "leads", label: "Leads", icon: "Target", path: "/backoffice/leads" },
  { key: "analytics", label: "Analytics", icon: "BarChart3", path: "/backoffice/analytics" },
  { key: "availability", label: "Staff Availability", icon: "Clock", path: "/backoffice/availability" },
  { key: "api_docs", label: "API Documentation", icon: "Code", path: "/backoffice/api-docs" },
  { key: "settings", label: "Settings", icon: "Settings", path: "/backoffice/settings" },
  { key: "audit_logs", label: "Audit Logs", icon: "ScrollText", path: "/backoffice/audit" }
];

// Get all menu keys for permission validation
export const ALL_MENU_KEYS = BACKOFFICE_MENUS.map(m => m.key);

// Get menu label by key
export const getMenuLabel = (key) => {
  const menu = BACKOFFICE_MENUS.find(m => m.key === key);
  return menu ? menu.label : key;
};
